// extracted by mini-css-extract-plugin
export default {"labelNormal":"LS7Akk8JgZCypuYVUgZp-navi-labelNormal","black":"eEUSgoLRl8QzZngPZksT-navi-black","white":"WOjNQzPNO2nIVRYWZ3dp-navi-white","active":"YPKvqGJxjX6nzEsgA1mv-navi-active"};